import Vue from 'vue'
import App from './App.vue'
import router from './router'
import tinymce from 'tinymce'
import VueTinymce from '@packy-tang/vue-tinymce'
import './plugins/element.js'
import axios from 'axios'
import './assets/index.less'
Vue.prototype.$tinymce = tinymce
Vue.use(VueTinymce)

Vue.prototype.$http = axios
//  axios.defaults.baseURL = 'http://127.0.0.1:8100/api/'
// axios.defaults.baseURL = 'http://110.41.53.8:8100/api/' 
axios.defaults.baseURL = 'http://txyadmin.ddyao.com:30026/api/' 

// http://119.23.74.131:12000/swagger-ui.html

axios.interceptors.request.use(config => {
  // console.log(config)
  config.headers.accessToken = window.sessionStorage.getItem('token')
  // config.headers. Access-Control-Allow-Credentials = '*'
 
  // 在最后必须 return config
  return config
})


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
